
























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Connector from '@vue-polkadot/vue-api';
import ItemCard from '@/components/shared/wrapper/ItemCard.vue'
import Money from '@/components/shared/format/Money.vue'
import WithLabel from '@/components/shared/format/WithLabel.vue'
import { AccountId } from '@polkadot/types/interfaces';
import { DeriveStakingQuery } from '@polkadot/api-derive/types';
import { StakerState } from './types'
import ActionModal from './ActionModal.vue'
import { notificationTypes, showNotification } from '@/utils/notification';
import exec from '@/utils/transactionExecutor';
import Nominators from '../Nominators.vue'

const components = {
  ItemCard,
  Money,
  WithLabel,
  ActionModal,
  Nominators
}

@Component({ components })
export default class ValidatorRow extends Vue {
  @Prop() public validator!: StakerState;
  @Prop() public index!: number;
  @Prop() private targetValidatorIds!: string[];

  private nominatorsVisible = false;

  get bonded() {
    return this.validator && this.validator.stakingLedger && this.validator.stakingLedger.total || 0
  }

  get nominating(): string[] {
    return this.validator && this.validator.nominating || []
  }

  get nominators(): [string, number][] {
    return this.nominating.map(v => [v, 0])
  }

  get commission() {
    const { validatorPrefs } = this.validator
    return validatorPrefs && validatorPrefs.commission || '0.00%'
  }

  private async handleStop() {
    try {
      const { validator, callback  } = this;
      const { controllerId: account } = validator 

      showNotification('Dispatched');
      const tx = await exec(account || '', null, callback, []);
      showNotification(tx, notificationTypes.success);
      console.timeStamp(`[handleStop] ${tx}`);
    } catch (e) {
      showNotification(e.message, notificationTypes.danger);
      console.error(e);
    }

  }

    get callback() {
    const { api } = Connector.getInstance();
    return api.tx.staking.chill;
  }


  get disabled() {
    return false;
  }

  private handleNominatorsVisibility() {
    this.nominatorsVisible = !this.nominatorsVisible;
  }

  get isStopVisible() {
    const { validator } = this
    return  validator.isStashNominating || validator.isStashValidating
  }

  
}
